/**
 * 性能优化工具函数
 * 用于防抖、节流和长任务拆分
 * 优化 INP (Interaction to Next Paint) 性能指标
 */

(function() {
  'use strict';

  // 防抖函数 - 延迟执行，直到停止触发后一段时间
  function debounce(func, wait, immediate = false) {
    let timeout;
    return function executedFunction(...args) {
      const context = this;
      const later = () => {
        timeout = null;
        if (!immediate) func.apply(context, args);
      };
      const callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) func.apply(context, args);
    };
  }

  // 节流函数 - 限制执行频率
  function throttle(func, limit) {
    let inThrottle;
    return function(...args) {
      if (!inThrottle) {
        func.apply(this, args);
        inThrottle = true;
        setTimeout(() => inThrottle = false, limit);
      }
    };
  }

  // 使用 requestAnimationFrame 的节流（适合滚动事件）
  function rafThrottle(func) {
    let rafId = null;
    return function(...args) {
      if (rafId === null) {
        rafId = requestAnimationFrame(() => {
          func.apply(this, args);
          rafId = null;
        });
      }
    };
  }

  // 长任务拆分工具 - 将大量操作拆分为多个小任务
  function chunkProcessor(items, processItem, chunkSize = 50, delay = 0) {
    return new Promise((resolve) => {
      let index = 0;
      
      function processChunk() {
        const end = Math.min(index + chunkSize, items.length);
        
        for (let i = index; i < end; i++) {
          processItem(items[i], i);
        }
        
        index = end;
        
        if (index < items.length) {
          setTimeout(processChunk, delay);
        } else {
          resolve();
        }
      }
      
      processChunk();
    });
  }

  // 导出到全局
  window.debounce = debounce;
  window.throttle = throttle;
  window.rafThrottle = rafThrottle;
  window.chunkProcessor = chunkProcessor;

  // 兼容性检查
  if (typeof requestAnimationFrame === 'undefined') {
    // 降级到 setTimeout
    window.rafThrottle = function(func) {
      return throttle(func, 16); // 约 60fps
    };
  }

})();
